<template>
  <div class="cv-bottom flex-start" :class="{'ios-cv-bottom': isIos}">
    <div class="list">
      <div class="item" v-for="(item,index) in operating" :key="item.type" @click="handleClick(item)">
        <div class="icon-container flex-center">
          <span class="iconfont" :class="[item.icon, index == 0 ? 'active-color': '']"></span>
        </div>
        <span class="label" :class="{'active-color': index == 0}">{{item.label}}</span>
      </div>
    </div>
    <!--    <div class="right theme-button flex-center" :class="{'job-has-click': jobState}"-->
    <!--         @click="handleClick({type: 'export'})">{{ pageText }}-->
    <!--    </div>-->
  </div>
</template>

<script>
	import { envMixin } from '../../assets/js/mixin/global'

	export default {
		name: 'cv-preview-bottom',
		mixins: [ envMixin ],
		props: {
			pageText: {
				type: String,
				default: '自动一页纸'
			}
		},
		data () {
			return {
				operating: [
					// { label: '导出', icon: 'icondaochu', type: 'export' },
          
          { label: '模板', icon: 'iconmoban', type: 'muban' },
					{ label: '布局', icon: 'iconbuju', type: 'buju' },
					{ label: '样式', icon: 'iconyangshi3', type: 'style' },
					// { label: '更多', icon: 'icongengduo', type: 'more' }
				],
				jobState: false
			}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {
			handleClick (item) {
				this.$emit('handleClick', item)
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .cv-bottom {
    position: fixed;
    bottom: 0;
    z-index: 10;
    width: 100vw;
    background-color: #181818;
    padding: 0px 42px;
    padding-top: 20px;
    @include ipx-footer(65px, 20px);
    box-sizing: border-box;
    .list {
      display: flex;
      flex: 1;
      align-items: center;
      height: 100%;
      justify-content: center;
      .item {
        color: $color-title;
        font-size: $font-size-small-s;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
             margin-right: 70px;
        .icon-container {
          // background-color: #303030;
          // border-radius: 50%;
          margin-bottom: 8px;
          .iconfont {
            color: #9C9C9C;
            font-size: 24px;
          
          }
        }
        .active-color {
          color: #fff !important;
        }
        .label {
          color: #9C9C9C;  
          font-weight: 500;
          font-size: $font-size-small;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .right {
      width: 174px;
      height: 38px;
      border-radius: 4px;
      margin-left: 18px;
    }
    .job-has-click {
      background-color: $color-theme;
      color: $color-light;
    }
  }
  .ios-cv-bottom {
    height: 56px !important;
    padding-bottom: 10px !important;
  }
</style>
